"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsurerAddress = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const address_entity_1 = require("./address.entity");
const insurer_entity_1 = require("./insurer.entity");
let InsurerAddress = class InsurerAddress {
};
exports.InsurerAddress = InsurerAddress;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], InsurerAddress.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "insurer_id" }),
    tslib_1.__metadata("design:type", Number)
], InsurerAddress.prototype, "insurerId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "address_id" }),
    tslib_1.__metadata("design:type", Number)
], InsurerAddress.prototype, "addressId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => insurer_entity_1.Insurer, (insurer) => insurer.insurerAddresses, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "insurer_id" }),
    tslib_1.__metadata("design:type", Object)
], InsurerAddress.prototype, "insurer", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => address_entity_1.Address, (address) => address.insurerAddresses, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "address_id" }),
    tslib_1.__metadata("design:type", Object)
], InsurerAddress.prototype, "address", void 0);
exports.InsurerAddress = InsurerAddress = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "insurer_address" })
], InsurerAddress);
